import { RangePicker } from '@cast/shared-date-ui';
import {
  CLUSTER_DASHBOARD_DEFAULT_PRESET,
  CLUSTER_DASHBOARD_FILTER_PRESETS,
  CLUSTER_DASHBOARD_QUERY_PARAM_KEYS,
  useClusterDashboardTimeRange,
} from '@cast/features-cluster-shared';
import { useCluster } from '@cast/shared-cluster-context-data-access';

export const ClusterDashboardRangePicker = () => {
  const { cluster } = useCluster();
  const { timeZone, constraints } = useClusterDashboardTimeRange();

  return (
    <RangePicker
      queryParamKeys={CLUSTER_DASHBOARD_QUERY_PARAM_KEYS}
      startMonth={cluster.createdAt}
      minDate={constraints?.minDate}
      maxDate={constraints?.maxDate}
      triggerInputProps={{
        size: 'small',
        sx: { minWidth: '300px' },
      }}
      filterPresets={CLUSTER_DASHBOARD_FILTER_PRESETS}
      initialPreset={CLUSTER_DASHBOARD_DEFAULT_PRESET}
      initialTimezone={timeZone}
      maxNumberOfDays={90}
      allowTimeInput
    />
  );
};
